import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { SideBarStore } from './types';
import { getValue, setValue } from '../../Utils/LocalStorageUtils';
import { SIDEBAR_OPEN_KEY } from '../../Constants/LocalStorage';

export const useSideBarStore = create<SideBarStore>()(
  devtools(
    set => ({
      open: getValue(SIDEBAR_OPEN_KEY) === 'true',
      // Actions
      toggleAction: () => {
        set(state => {
          const newOpen = !state.open;
          setValue(SIDEBAR_OPEN_KEY, newOpen);
          return { open: newOpen };
        });
      },
    }),
    {
      name: 'SideBarModule',
      store: 'SideBarModuleStore',
    },
  ),
);
